<template>
  <md-dialog :md-active.sync="active">
    <md-dialog-title>
      {{ message }}
    </md-dialog-title>
    <md-dialog-content>
      {{ subMessage }}
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-raised" @click="close">
        <font-awesome-icon icon="times-circle" />
        閉じる
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import Component from 'vue-class-component'
import BaseDialog from '@/components/dialogs/BaseDialog'

/**
 * エラーダイアログ
 *
 * 使い方
 *
 * ```javascript
 * this.$dialog
 *   .open(ErrorDialog, {
 *     message: "サーバーエラーが発生しました。",
 *   });
 * ```
 */
@Component({
  props: {
    /**
     * メインメッセージ
     *
     * 操作の種類、Yes/No部分の確認内容はここに記載する。
     * 例）削除します。よろしいですか？
     */
    message: String,
    /**
     * 補助メッセージ
     *
     * 詳細や列挙項目等はここに記載する。
     */
    subMessage: String,
  },
})
export default class ErrorDialog extends BaseDialog {
  /**
   * 「閉じる」選択
   */
  close() {
    this.hide()
  }
}
</script>

<style lang="scss" scoped>
.md-dialog {
  z-index: 1000;
}
.md-overlay {
  z-index: 100;
}
</style>
